import React, { useState, useMemo } from 'react';
import styles from './ContactUsModal.module.scss';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { Input } from '@/components/Input';
import { PhoneInput } from '@/components/PhoneInput';
import { Button } from '@/components/Button';
import httpClient from '@/config/httpClient';
import { TextArea } from '@/components/TextArea';
import { addNotification, notificationStates } from '@/components/Notification';
import { personalDomains } from './ContactUsModal.constants';
export const ContactUsModal = ({ onClose, isEnterpriseQuery }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    companyName: '',
    phone: '',
    message: '',
  });
  const handleChange = ({ key, value }) => {
    setFormData({ ...formData, [key]: value });
  };
  const isCorporateEmail = (email) => {
    if (!email) return false;

    const domain = email.split('@')[1]?.toLowerCase();

    if (!domain) return false;

    return !personalDomains.includes(domain);
  };
  const isSubmitDisabled = () => {
    let disabled = false;
    const keysToCheck = ['name', 'email', 'companyName', 'phone'];
    keysToCheck.forEach((key) => {
      if (!formData[key]) {
        disabled = true;
      }
    });
    return disabled;
  };

  const { emailError, isValidCorporateEmail } = useMemo(() => {
    const isValidCorporateEmail = isCorporateEmail(formData.email);
    const emailError =
      !isValidCorporateEmail && formData.email
        ? 'Please enter a corporate email'
        : '';
    return {
      emailError,
      isValidCorporateEmail,
    };
  }, [formData.email]);
  const formatTextAreaValue = (value) => {
    return value.replace(/\\n/g, '\n').trim();
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const payload = {
      name: formData.name,
      email: formData.email,
      companyName: formData.companyName,
      phone: formData.phone,
      message: formatTextAreaValue(formData.message),
      isEnterpriseQuery,
    };
    try {
      const response = await httpClient.post('/contactUs', payload);
      if (response.data.success) {
        addNotification({
          message: response.data.message,
          level: notificationStates.success,
          autoDismiss: 4,
        });
        onClose();
      }
    } catch (error) {
      console.error('Error in handleSubmit:', error);
      addNotification({
        message:
          error.response.data.message ||
          'Something went wrong! Please try later.',
        level: notificationStates.error,
        autoDismiss: 4,
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className={styles.contactUsModal}>
      <Text
        variant={textVariantsEnum.Text_xl}
        fontWeight={fontWeightEnum.Medium}
      >
        Contact Us
      </Text>
      <div className={styles.formContainer}>
        <Input
          label="Name"
          placeholder="Enter your name"
          value={formData.name}
          disabled={isLoading}
          onChange={(e) => handleChange({ key: 'name', value: e.target.value })}
          // successMessage="Name is required"
        />
        <Input
          label="Email"
          placeholder="Enter your email"
          type="email"
          errorMessage={emailError}
          value={formData.email}
          disabled={isLoading}
          onChange={(e) =>
            handleChange({ key: 'email', value: e.target.value })
          }
        />
        <Input
          label="Company Name"
          placeholder="Enter your company name"
          // successMessage="Company name is required"
          value={formData.companyName}
          disabled={isLoading}
          onChange={(e) =>
            handleChange({ key: 'companyName', value: e.target.value })
          }
        />
        <PhoneInput
          label="Phone"
          placeholder="Enter your phone"
          // successMessage="Phone is required"
          value={formData.phone}
          disabled={isLoading}
          onChange={(value) => handleChange({ key: 'phone', value })}
        />
        <TextArea
          label="Message"
          placeholder="Enter your message"
          value={formData.message}
          rows={5}
          disabled={isLoading}
          onChange={(e) =>
            handleChange({ key: 'message', value: e.target.value })
          }
        />
      </div>
      <div className={styles.buttonContainer}>
        <Button
          text="Submit"
          onClick={handleSubmit}
          disabled={isSubmitDisabled() || !isValidCorporateEmail}
          loading={isLoading}
        />
      </div>
    </div>
  );
};
